"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.isTabActive = exports.default = void 0;
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/includes"));
var _some = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/some"));
var _react = _interopRequireWildcard(require("react"));
var _tkUiSubNav = require("@xo-union/tk-ui-sub-nav");
var _SubNavElementLinkMenu = _interopRequireDefault(require("../SubNavElementLinkMenu/SubNavElementLinkMenu.js"));
var _tkComponentIcons = _interopRequireDefault(require("@xo-union/tk-component-icons"));
var _SubNavElementLinkModule = _interopRequireDefault(require("./SubNavElementLink.module.css"));
var _reactCssModules = require("@xo-union/react-css-modules");
var _SubNavContext = require("../../context/SubNavContext.js");
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const isTabActive = (href, links) => {
  const currentUrl = window.location.href;
  const doesUrlMatchTopLevelLink = (0, _includes.default)(currentUrl).call(currentUrl, href);
  const doesUrlMatchChildLink = (0, _some.default)(links).call(links, link => (0, _includes.default)(currentUrl).call(currentUrl, link.href));
  const doesUrlMatchAnyLink = doesUrlMatchTopLevelLink || doesUrlMatchChildLink;
  return doesUrlMatchAnyLink;
};
exports.isTabActive = isTabActive;
const SubNavElementLink = _ref => {
  let {
    text,
    href,
    target,
    links
  } = _ref;
  const [isHovering, setIsHovering] = (0, _react.useState)(false);
  const [isActive, setIsActive] = (0, _react.useState)(false);
  const openMenu = () => {
    setIsHovering(true);
  };
  const closeMenu = () => {
    setIsHovering(false);
  };
  const onKeyDownHandlerAccessibilityButton = event => {
    if (event.key === 'Escape') {
      closeMenu();
    }
    if (event.key === 'Enter') {
      event.preventDefault();
      openMenu();
    }
  };
  const onBlurHandlerMenu = e => {
    const currentTarget = e.currentTarget;
    const relatedTarget = e.relatedTarget;
    if (relatedTarget && !currentTarget.contains(relatedTarget)) {
      closeMenu();
      const previousSibling = currentTarget === null || currentTarget === void 0 ? void 0 : currentTarget.previousElementSibling;
      previousSibling === null || previousSibling === void 0 || previousSibling.focus();
    }
  };
  (0, _react.useEffect)(() => {
    setIsActive(isTabActive(href, links));
  }, []);
  const {
    trackMenuInteraction
  } = (0, _react.useContext)(_SubNavContext.SubNavContext);
  const classOverrides = (0, _reactCssModules.compose)({
    link: _SubNavElementLinkModule.default.subNavElementLink__link
  });
  return /*#__PURE__*/_react.default.createElement(_tkUiSubNav.SubNavLink, {
    href: href,
    onClick: () => trackMenuInteraction === null || trackMenuInteraction === void 0 ? void 0 : trackMenuInteraction(text),
    target: target,
    active: isActive || isHovering,
    onMouseEnter: openMenu,
    onMouseLeave: closeMenu,
    onBlur: onBlurHandlerMenu,
    classes: classOverrides,
    "data-testid": "SubNavElementLink"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: _SubNavElementLinkModule.default.subNavElementLinkMenu__wrapper
  }, /*#__PURE__*/_react.default.createElement("div", null, text), /*#__PURE__*/_react.default.createElement("div", {
    className: _SubNavElementLinkModule.default.subNavElementLink__menuExpander
  }, /*#__PURE__*/_react.default.createElement("button", {
    onClick: openMenu,
    onKeyDown: onKeyDownHandlerAccessibilityButton,
    "aria-expanded": isHovering,
    "aria-controls": text,
    "data-testid": "SubNavElementLink__accessibilityControl"
  }, /*#__PURE__*/_react.default.createElement(_tkComponentIcons.default, {
    name: "arrow_down",
    size: "sm",
    "aria-hidden": "true"
  }))), isHovering && /*#__PURE__*/_react.default.createElement(_SubNavElementLinkMenu.default, {
    onBlur: onBlurHandlerMenu,
    links: links
  })));
};
var _default = exports.default = SubNavElementLink;